import Button from "@material-tailwind/react/Button";
import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import CardFooter from "@material-tailwind/react/CardFooter";
import CardImage from "@material-tailwind/react/CardImage";
import H6 from "@material-tailwind/react/Heading6";
import Small from "@material-tailwind/react/Small";
import React from 'react';

const BlogCard = (props) => {
    const { name, image, description, link } = props.data;
    return (
        <Card className="w-full m-2">
            <CardImage
                src={image}
                alt="Card Image"
            />

            <CardBody>
                <H6 color="gray">{name}</H6>
                <div className="lg:block md:block hidden">
                    <Small color="gray">
                        {description}
                    </Small>
                </div>


            </CardBody>

            <CardFooter>
                <Button
                    color="lightBlue"
                    buttonType="link"
                    size="regular"
                    rounded={false}
                    block={false}
                    iconOnly={false}
                    ripple="dark"
                    className="mx-auto"
                >
                    <a href={link} target="_blank" rel="noopener noreferrer">Read</a>
                </Button>
            </CardFooter>
        </Card>
    );
};

export default BlogCard;